import { enqueueSnackbar } from 'notistack';

import { Box } from '@mui/system';
import { Chip, ChipProps, Typography } from '@mui/material';

import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';

import { useOrgHierarchy } from 'src/hooks/auth/use-org-hierarchy';

import { useTranslate } from 'src/locales';

import Iconify from 'src/components/iconify';

import { TenantHierarchyLevel } from 'src/types/enums';

// ----------------------------------------------------------------------

type Props = {
  text?: string;
  onNavigate?: () => void;
} & ChipProps;

export default function FeatureLockedListView({
  text,
  onNavigate,
  ...chipProps
}: Props) {

  const { t } = useTranslate();
  const router = useRouter();

  const tenantHierarchy = useOrgHierarchy();

  const handleClick = () => {
    if (tenantHierarchy === TenantHierarchyLevel.PARENT) {
      router.push(paths.dashboard.admin.billing.root)
      onNavigate?.();
    }
    else {
      enqueueSnackbar(t('billing.sub_tenant_feature_locked_message'), { variant: 'warning' });
    }
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
      <Box
        onClick={handleClick}
        sx={{
          p: 2,
          width: '100%',
          height: '100%',
          display: 'flex',
          cursor: 'pointer',
          borderRadius: 1,
          alignItems: 'center',
          flexDirection: 'column',
          justifyContent: 'center',
          backdropFilter: 'blur(6px)',
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          border: (theme) => `1px dashed ${theme.palette.divider}`,
        }}
      >
        <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1 }}>
          {text ?? t('billing.feature_locked')}
        </Typography>

        <Chip
          color="primary"
          size="small"
          label={t('common.upgrade')}
          icon={<Iconify icon="ep:lock" width={15} height={15} />}
          {...chipProps}
        />
      </Box>
    </Box>
  );
}
